// Assets
import heroImage from '../../assets/img/hero/eggplant-involtini-hero.jpg';
import thumbnail from '../../assets/img/recipes/eggplant-involtini-thumb.jpg';

export default {
  hasTransparentNav: false,
  hasRebateCallout: true,
  metadata: {
    title: 'Eggplant Involtini by Chef Candace Conley',
    description:
      'Take your waffle-making skills up a notch with these two recipes from Chef Candace Conley. Crispy fried chicken paired with traditional Belgian-style waffles topped with a spicy honey sauce or savory potato leek waffles smothered in smoked jalapeno gravy.',
    type: 'video.episode'
  },
  active: true,
  title: 'Eggplant Involtini',
  hero: {
    image: heroImage,
    video: '',
    title: '',
    cta: '',
    link: ''
  },
  episode: 'S1:E1',
  episodeLong: 'Season One Episode One',
  className: 'episode-detail',
  thumbnail,
  content:
    'Take your waffle-making skills up a notch with these two recipes from Chef Candace Conley. Crispy fried chicken is a no-brainer here, so there’s just two questions to ask yourself: Do you go for traditional Belgian-style waffles topped with a spicy honey sauce? Or savory potato leek waffles smothered in smoked jalapeño gravy? Hard to decide, but neither are hard to make.',
  excerpt:
    'Chef Candace Conley loves to take unexpected ingredients and turn them into comfortable classics that seem like they’ve been around for ages. ',
  videoIds: ['6_W0F6Z32Io'],
  playlistId: 'PL6bvPOjDXPzijS0wUPlVnGauAG99P2Ojn',
  url: '/episodes/eggplant-involtini',
  recipe: 'steakAndRisotto',
  chef: 'melissaAust',
  season: 1
};
